import { useState } from 'react';
import './AlertsPanel.css';

/* „Riasztás-levelek leállítása" — a riasztás-levél aljáról (aláírt link,
   bejelentkezés nélkül). Gombnyomásra POST-ol az alert-email-stop függvénynek:
   a levelezők linkellenőrzője így nem állíthatja le véletlenül. A marketing-
   leiratkozástól független; a riasztások megmaradnak. */
const FN = `${process.env.REACT_APP_SUPABASE_URL || 'https://ggeeqexormqnazwxzbsy.supabase.co'}/functions/v1/alert-email-stop`;

export default function AlertEmailStopPage() {
  const q = new URLSearchParams(window.location.search);
  const u = q.get('u'), t = q.get('t');
  const [state, setState] = useState(u && t ? 'ready' : 'bad'); // ready | busy | done | bad | error

  const stop = async () => {
    setState('busy');
    try {
      const res = await fetch(FN, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ u, t }) });
      setState(res.ok ? 'done' : res.status === 400 ? 'bad' : 'error');
    } catch { setState('error'); }
  };

  return (
    <main className="alp-stop">
      <div className="alp-stop-card">
        <div className="alp-stop-eyebrow">Kripto Terminál · riasztások</div>
        {state === 'done' ? (
          <>
            <h1>Riasztás-levelek leállítva</h1>
            <p>A riasztásaidról nem küldünk több e-mailt. A riasztásaid megmaradtak: ahol a Telegram is be volt állítva, ott továbbra is szólnak, a csak e-mailes riasztások szünetelnek.</p>
            <p>Az e-mailt a terminálban kapcsolhatod vissza: Riasztások (🔔) → a riasztásnál „E-mail be”, majd a szünetelőknél „Folytatás”.</p>
            <a className="alp-btn-primary" href="/?riasztasok=1">Riasztásaim →</a>
          </>
        ) : state === 'bad' ? (
          <>
            <h1>Érvénytelen link</h1>
            <p>Ez a link hiányos vagy hibás. Nyisd meg a legutóbbi riasztás-leveled alján lévő linket, vagy kapcsold ki az e-mailt a terminálban.</p>
            <a className="alp-btn-primary" href="/?riasztasok=1">Riasztásaim →</a>
          </>
        ) : (
          <>
            <h1>Riasztás-levelek leállítása</h1>
            <p>A riasztásaidról nem küldünk több e-mailt. A riasztások megmaradnak; ahol a Telegram is be van állítva, ott továbbra is szólnak. Ez nem érinti a hírleveleket.</p>
            {state === 'error' && <p className="alp-stop-err">Nem sikerült. Próbáld újra néhány perc múlva.</p>}
            <button type="button" className="alp-btn-primary" onClick={stop} disabled={state === 'busy'}>
              {state === 'busy' ? 'Leállítás…' : 'Riasztás-levelek leállítása'}
            </button>
          </>
        )}
      </div>
    </main>
  );
}
